// import packages
import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import {LoadingOutlined} from '@ant-design/icons'
import {isEmail} from "validator";

// Import assets
import "./contact.scss"
import { TickIcon} from "../../assets/images";

// Import Components
import {InputGroup} from "../../components/ui-elements/input-group/inputGroup";
import {YMaps, Map, Placemark} from "@pbe/react-yandex-maps";

// Import utils
import {getPropsFromState} from "../../redux/mapStateToProps";
import {SendMessage} from "../../redux/actions";
import HeaderWrapper from "../../components/HeaderWrapper/HeaderWrapper";
import Subscription from "../../components/subscription/Subscription";
import {PROJECT_LINK} from "../../constants/constants";
import MapModal from "../../components/modal/mapModal/MapModal";


function Contact(props) {
    const [tick, setTick] = useState(false)
    const {requestLoading, contact, staticTexts} = props

    const [fieldsData, setFieldsData] = useState({
        name: "",
        email: "",
        phone: "",
        message: "",
    })
    const [errors, setErrors] = useState({
        name: "",
        email: "",
        phone: "",
        message: "",
    })
    const [visible, setVisible] = useState(false)

    const showTick = () => {
        setTimeout(
            () => {
                setTick(false)
                setErrors({
                    name: "",
                    email: "",
                    phone: "",
                    message: "",
                })
                setFieldsData({
                    name: "",
                    email: "",
                    phone: "",
                    message: "",
                })
            },
            2000,
        )

    }

    function getInputValues(e) {
        const {name, value} = e.target
        if (name === "phone" && value && !/^[+\d]\d*$/.test(value)) {
            return
        }
        setFieldsData({
            ...fieldsData,
            [name]: value
        })

        setErrors({
            ...errors,
            [name]: false,
        })
    }

    function validate() {
        const errors = {};
        let result = true;
        Object.keys(fieldsData).forEach(key => {
            if (!fieldsData[key] || (key === 'email' && !isEmail(fieldsData?.email))
            ) {
                errors[key] = true;
                result = false;
            }
        })
        setErrors(errors);
        return result;
    }

    const sendMessage = () => {

        if (validate()) {

            props.SendMessage(fieldsData).then(() => {
                setTick(true)
                showTick()
            })
        }
    }

    useEffect(()=>{
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    },[])

    function closeModal() {
        setVisible(!visible)
    }

    const mapData = {
        center: [contact?.location?.latitude, contact?.location?.longitude],
        zoom: 14,
    }

    return <div className={'contact-page'}>
        <HeaderWrapper addressFirst={staticTexts?.header_item_contact}
                       title={staticTexts?.contacts_page_title}/>
        {/*<div className="contact-page-row">*/}
            <div className={'map-wrapper'}>
                <YMaps query={{
                    apikey: 'c5f70ecb-be1a-4260-9292-9ecafceda596',
                    lang: 'en'
                }}>
                    <Map defaultState={mapData}
                         cursors={"inherit"}
                         className={'yandexMap'}>
                        <Placemark
                            geometry={[contact?.location?.latitude, contact?.location?.longitude]}
                            classname={'customIcon'}
                            // options={{
                            //     iconLayout: 'default#image',
                            //     iconImageHref:PROJECT_LINK.iconUrl,
                            //     iconImageSize: [28, 28],
                            //     // iconImageOffset: [-15, -60],
                            // }}
                        />
                        <Placemark
                            geometry={[contact?.office_location?.latitude, contact?.office_location?.longitude]}
                            classname={'customIcon'}
                            // options={{
                            //     iconLayout: 'default#image',
                            //     iconImageHref:PROJECT_LINK.iconUrl,
                            //     iconImageSize: [28, 28],
                            //     // iconImageOffset: [-15, -60],
                            // }}
                        />
                    </Map>
                </YMaps>
            </div>
            <div className="message-wrapper">
                <div className="title">{staticTexts?.contacts_page_left_subTitle}</div>
                <div className="description">
                    {staticTexts?.contacts_page_left_text}
                </div>

                <InputGroup
                    inputType={'input'}
                    type={"text"}
                    value={fieldsData.name}
                    error={errors.name}
                    name={'name'}
                    maxLength={30}
                    placeholder={staticTexts?.contacts_page_placeholder_name}
                    onChange={getInputValues}
                />
                <InputGroup
                    inputType={'input'}
                    type={"text"}
                    value={fieldsData.email}
                    error={errors.email}
                    name={'email'}
                    maxLength={50}
                    placeholder={staticTexts?.contacts_page_placeholder_email}
                    onChange={getInputValues}
                />
                <InputGroup
                    inputType={'input'}
                    type={"text"}
                    value={fieldsData.phone}
                    error={errors.phone}
                    name={'phone'}
                    maxLength={30}
                    placeholder={staticTexts?.contacts_page_placeholder_phoneNumber}
                    onChange={getInputValues}
                />
                <InputGroup
                    inputType={'textarea'}
                    type={"text"}
                    value={fieldsData.message}
                    error={errors.message}
                    name={'message'}
                    placeholder={staticTexts?.contacts_page_placeholder_message}
                    onChange={getInputValues}
                />
                <button className='PrimaryButton'
                        onClick={() => {
                            if (!requestLoading && sendMessage) {
                                sendMessage();
                            }
                        }}
                >
                    {staticTexts?.contacts_page_btn_send_message}
                    {/*{*/}
                    {/*    requestLoading ? <LoadingOutlined style={{fontSize: 14, color: "#fff"}}*/}
                    {/*                                      className={'loading-icon'}/>*/}
                    {/*        : <TickIcon title={''} className={`tick-icon ${tick ? 'show-tick' : 'hide-tick'}`}/>*/}
                    {/*}*/}
                </button>
            </div>
        {/*</div>*/}

        {/*<div className="address-wrapper">*/}
        {/*    <div className="title">{staticTexts?.contacts_page_address_title}</div>*/}
        {/*    <div className="address" onClick={()=> setVisible(true)}>{contact?.address}</div>*/}
        {/*</div>*/}

        <div className="contact-info">
            <div className="title">{staticTexts?.contacts_page_right_subTitle}</div>
            <div className="line"/>
            <div className="info-row">
                <div className={'info-item'}>
                    <div className={'info-item-text'}>{staticTexts?.contacts_page_info_phone_title}</div>
                    <a href={`tel:${contact?.phoneNumber}`} className={'info-value'}>
                        {contact?.phoneNumber}
                    </a>
                </div>
                <div className="line"/>
                <div className={'info-item'}>
                    <div className={'info-item-text'}>{staticTexts?.contacts_page_info_address_title}</div>
                    <a href={`tel:${contact?.phoneNumber2}`} className={'info-value'}>
                        {contact?.phoneNumber2}
                    </a>
                </div>
                <div className="line"/>
                <div className={'info-item'}>
                    <div className={'info-item-text'}>{staticTexts?.contacts_page_info_email_title}</div>
                    <a href={`mailto:${contact?.email}`}  className={'info-value'}>
                        <p>{contact?.email}</p>
                    </a>
                </div>
            </div>
            <div className="line"/>
        </div>
        <div className="address-wrapper">
            <div className="title">{staticTexts?.contacts_page_address}</div>
            <div className="address" onClick={()=> setVisible(true)}>{contact?.address}</div>
        </div>
        {/*<Subscription/>*/}

        {
            visible && <MapModal closeModal={closeModal}
                                 visible={visible}/>
        }
    </div>
}

const mapStateToProps = (state) => getPropsFromState(state, [
    'requestLoading',
    'staticTexts',
    'about',
    'contact',
    'selectedLanguage'
]);

const mapDispatchToProps = {
    SendMessage
};

export default connect(mapStateToProps, mapDispatchToProps)(Contact);
